import type { SpartacuxProductDiscoveryDomainState } from '@/domains/productDiscovery/productDiscovery.model';

import type { Product } from '../../algolia/interfaces/product';
import { selectListing } from './listing';

const DEFAULT_PRODUCTS: Product[] = [];

export const selectProducts = <P extends Product = Product>(
  state: SpartacuxProductDiscoveryDomainState,
): P[] => selectListing<P>(state)?.products || (DEFAULT_PRODUCTS as P[]);

export const selectFetchingProducts = (
  state: SpartacuxProductDiscoveryDomainState,
): boolean => selectListing(state)?.fetchingAlgolia || false;
